//src/theme/globalStyles.ts
import styled, { createGlobalStyle } from 'styled-components';
import colors from './palette';
import { breakpoints } from './breakpoints';

export const GlobalStyles = createGlobalStyle`
  :root {
    --color-primary: ${colors.primary};
    --color-secondary: ${colors.secondary};
    --color-background: ${colors.background};
    --color-body-background: ${colors.bodyBackground};
    --color-text: ${colors.text};
    --color-text-light: ${colors.lightText};
    --color-highlight: ${colors.highlight};
    --color-disabled: ${colors.disabled};
    --color-success: ${colors.success};
    --color-danger: ${colors.danger};
    --color-warning: ${colors.warning};
    --color-info: ${colors.info};
    --color-icon: ${colors.iconColor};
    --color-link: ${colors.linkColor};
    --color-link-hover: ${colors.linkHover};
    --color-primary-hover: ${colors.primaryHover};
    --color-new-button: ${colors.newButtonColor};
    --color-new-button-hover: ${colors.newButtonHover};
    --color-new-button-active: ${colors.newButtonActive002};
    --color-new-button-active-hover: ${colors.newButtonActiveHover};
    --color-button-text: ${colors.buttonTextColor};
    --seal-brown: #442410ff;
    --caf-noir: #473120ff;
    --licorice: #27150Cff;
    --russet: #83491Bff;
    --bistre: #2F2115ff;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
  }

  body {
    background-color: var(--color-body-background);
    color: var(--color-text);
    font-family: Arial, sans-serif;
    line-height: 1.5;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 1rem;
    font-weight: bold;
    color: var(--color-text);
    line-height: 1.3;
  }

  p {
    margin-bottom: 1rem;
    text-align: left;
    color: var(--color-text);
  }

  a {
    text-decoration: none;
    color: var(--color-link);
    transition: color 0.3s;

    &:hover,
    &:focus {
      color: var(--color-link-hover);
      outline: none;
    }

    &:focus-visible {
      outline: 3px solid var(--color-highlight);
      outline-offset: 2px;
    }
  }

  button {
    font-family: inherit;
    font-size: 1rem;
    padding: 0.75rem 1.5rem;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    background-color: var(--color-primary);
    color: #fff;
    transition: background-color 0.3s, color 0.3s;

    &:focus-visible {
      outline: 3px solid var(--color-highlight);
      outline-offset: 2px;
    }

    &:hover {
      background-color: var(--color-primary-hover);
    }

    &:disabled {
      background-color: var(--color-disabled);
      cursor: not-allowed;
      color: #666;
    }
  }

  button.outline {
    background-color: transparent;
    border: 2px solid var(--color-text);
    color: var(--color-text);

    &:hover {
      background-color: var(--color-text);
      color: #fff;
    }

    &:disabled {
      background-color: transparent;
      color: #666;
      border-color: #666;
    }
  }

  button.secondary {
    background-color: var(--color-secondary);
    color: #fff;

    &:hover {
      background-color: var(--color-highlight);
      color: var(--color-text);
    }

    &:disabled {
      background-color: var(--color-disabled);
      color: #666;
    }
  }

  button.new-button {
    background-color: var(--color-new-button);
    color: #fff;

    &:hover {
      background-color: var(--color-new-button-hover);
    }

    &:disabled {
      background-color: var(--color-disabled);
      color: #666;
    }
  }
`;

export const Container = styled.div`
  width: 100%;

  @media (min-width: ${breakpoints.tablet}) {
    padding: 0 2rem;
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding: 0 3rem;
  }
`;
